import { motion } from "framer-motion";

export const EASE = [0.16, 1, 0.3, 1];

export const Reveal = ({
    children,
    delay = 0,
    y = 36,
    className = "",
    as = "div",
}) => {
    const MotionTag = motion[as] || motion.div;
    return (
        <MotionTag
            className={className}
            initial={{ opacity: 0, y }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.15 }}
            transition={{ duration: 0.8, delay, ease: EASE }}
        >
            {children}
        </MotionTag>
    );
};

export default Reveal;
